// Module
var code = "<svg fill=none xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><path stroke-width=2 stroke-linecap=round stroke-linejoin=round d=\"M2 4h2.3M4.5 4l4 13M19 8l-1 5.5M8.5 17H20M8 13.5h10M6 8h13\"/><circle cx=10.5 cy=20.5 r=1.5 /><circle cx=19.5 cy=20.5 r=1.5 /></svg> ";
// Exports
module.exports = code;